// extracted by mini-css-extract-plugin
module.exports = {"container":"betslip__container___2h_Wl"};